import React, { useState, useEffect } from 'react';
import { css } from 'styled-components';

// Components
import Layout from 'src/components/common/theme/Layout';
import { Typo } from 'src/components/common/ui';

//helpers
import { checkValue, getCurlyQuotes } from 'src/components/common/helper';

//types
import { HeroTextProps } from '../../typings';
import {
  mediaQueries,
  setFontFormat,
  setFontFormatHero,
  setFontSizeHeroModule,
  setFontSizeSubheadingHeroModule,
  titleWeight,
} from 'src/components/common/theme/component-styles';

const HeroText: React.FC<HeroTextProps> = (props) => {
  const {
    heroTitleDesktop,
    heroSubTextDesktop,
    heroTitleMobile,
    textSize,
    heroSubTextMobile,
    textColor,
    heroStyle = 'text-left',
    heroTitleWidth,
    heroSubTextWidth,
    hideSubheadlineOnMobile
  } = props;

  const [heroTitle, setHeroTitle] = useState('');
  const [heroDescription, setHeroDescription] = useState('');

  useEffect(() => {
    if (window) {
      setData();

      window.addEventListener('resize', () => {
        setData();
      });
    }
  }, []);

  const setData = () => {
    const isMobile = document.body.offsetWidth < 768;

    setHeroTitle(heroTitleDesktop);
    setHeroDescription(heroSubTextDesktop);

    if (isMobile) {
      if (heroTitleDesktop !== heroTitleMobile && checkValue(heroTitleMobile)) {
        setHeroTitle(heroTitleMobile);
      }
      if (heroSubTextDesktop !== heroSubTextMobile && checkValue(heroSubTextMobile)) {
        setHeroDescription(heroSubTextMobile);
      }
    }
  };

  const moduleCss = () => {
    const titleSizeDesktopMap: any = setFontSizeHeroModule(textSize);
    const subTitleSizeDesktopMap: any = setFontSizeSubheadingHeroModule(textSize);
    const titleSizeDesktop = titleSizeDesktopMap.desktop;
    const titleSizeMobile = titleSizeDesktopMap.mobile;
    const subTitleSizeDesktop = subTitleSizeDesktopMap.desktop;

    return `
        &.hero-text-component {
          ${
            checkValue(textColor)
              ? `
            .hero-title,
            .hero-sub-title{
              color:${textColor} !important;
            }
          `
              : ''
          }
          ${checkValue(heroTitleWidth) ? `.hero-title {max-width: ${heroTitleWidth} !important;}` : ''}
          ${checkValue(heroSubTextWidth) ? `.hero-sub-title {max-width: ${heroSubTextWidth}!important;}` : ''}

          @media only screen and (max-width: 768px) {
            ${checkValue(heroTitleWidth) ? `.hero-title {max-width: 100% !important;}` : ''}
            ${checkValue(heroSubTextWidth) ? `.hero-sub-title {max-width: 100% !important;}` : ''}
          }
        }
        
        ${setFontFormatHero('&.hero-text-component .hero-sub-title', subTitleSizeDesktop, '400', `${textColor}`)}
        &.hero-text-component .hero-sub-title{
          max-width: ${checkValue(textSize) && textSize === 'Large' ? '1018px' : textSize === 'Medium' ? '800px' : ''}
        }
    `;
  };

  return (
    <Layout
      css={css`
        ${moduleCss()}
      `}
      className={`hero-text-component ${heroStyle.toLowerCase()} ${hideSubheadlineOnMobile === "True" ? "no-mobile-subheadline" : ""}`}
    >
      {checkValue(heroTitle) && (
        <Typo.HTMLText tag="h1" exClass="override-heading-font-family hero-title">
          {getCurlyQuotes(heroTitle)}
        </Typo.HTMLText>
      )}
      {checkValue(heroDescription) && (
        <Typo.HTMLText tag="p" exClass="hero-sub-title">
          {heroDescription}
        </Typo.HTMLText>
      )}
    </Layout>
  );
};

export default HeroText;
